export const LocalStorageService = Symbol.for('LocalStorageService');
